import {$, HttpBody, ID, Resource, ResponseSerialize} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'

export default class EmailAlertaNotaAtraso extends Resource {
  static async listEmailAlertaNotaAtraso(spinner = 'listEmailAlertaNotaAtraso') {
    const fetch = async () => {
      // @ts-ignore
      return await new HttpBody<EmailAlertaNotaAtraso[]>(EmailAlertaNotaAtraso).GET('/user/email-alerta-nota-atraso')
    }

    return await $.await.run(fetch, spinner)
  }

  static async listCpfCnpjAlertaNotaAtraso(spinner = 'listCpfCnpjAlertaNotaAtraso') {
    const fetch = async () => {
      return await new HttpBody<string[]>(Array).GET('/user/email-alerta-nota-atraso/cpfCnpj')
    }

    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'EmailAlertaNotaAtraso'

  readonly $endpoint: string = '/user/email-alerta-nota-atraso{/id}'

  get $id() {
    return this.cpfCnpj || ''
  }

  get $tag() {
    return this.cpfCnpj ? Helper.cpfOrCnpj(this.cpfCnpj) : ''
  }

  @ResponseSerialize(Responsavel)
  responsavelLogado = new Responsavel()

  @ResponseSerialize(Responsavel)
  transportador: Responsavel | null = null

  email: string | null = null
  cpfCnpj: string | null = null

  get idResponsavelLogadoFk() {
    if (!this.responsavelLogado) return 0
    return this.responsavelLogado.$id
  }

  set idResponsavelLogadoFk(idResponsavelFk: ID) {
    if (!this.responsavelLogado) this.responsavelLogado = new Responsavel()
    this.responsavelLogado.$id = idResponsavelFk
  }

  async listEmailsByCpfCnpj(spinner = 'listEmailsByCpfCnpj') {
    const fetch = async () => {
      return await new HttpBody<string[]>(Array).GET(`/user/email-alerta-nota-atraso/${this.cpfCnpj}`)
    }

    return await $.await.run(fetch, spinner)
  }
}
